<template>
  <div class="car-dialog-containter">
    <div class="inner">
      <div class="title">
        <div class="tit">{{ numberPlate }}车辆信息({{ online }})</div>
        <div class="close" @click="close">
          <i class="iconfont icon-close-hei"></i>
        </div>
      </div>
      <div class="box">
        <el-tabs tab-position="left">
          <el-tab-pane label="车辆信息"
            ><div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">租车人</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ name }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">车架号</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ frame_num }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">租车人电话</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ phone }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">车牌号</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ number_plate }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">到期日期</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ endTime }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">ICCID</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ iccid }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">TBOX编号</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ sn }}</div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="车辆状态">
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">清水水量</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ water_clear }}L</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">灰水水量</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ greyWater }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">黑水水量</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ blackWater }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">电池电压</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ voltage }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">剩余电量</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ remaining_battery }}%</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">抽拉仓状态</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ drawBinStatus }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">手刹状态</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ handbrake }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">车门状态</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ gateSignal }}</div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="车辆告警">
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">异常闯入告警</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ abnormalInvasion }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">燃气告警</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ gasAlarm }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">烟雾告警</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ smokeAlarm }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">电池电压告警</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ powerAlarm }}</div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="车辆位置">
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">GPS位置</div>
                </el-col>
                <el-col :span="4">
                  <div class="value GPS">{{ longitude }},{{ latitude }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">GPS速度</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ speed }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">海拔高度</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ asl }}</div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="维护记录">
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">问题描述</div>
                </el-col>
                <el-col :span="4">
                  <div class="value GPS">{{ mainTain.problem || '--' }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">状态</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">
                    {{ statusList[mainTain.status] || '--' }}
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="label">经办人</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ mainTain.person || '--' }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">提交时间</div>
                </el-col>
                <el-col :span="4">
                  <div class="value GPS">
                    {{ mainTain.create_time || '--' }}
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="label">解决时间</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ mainTain.solve_time || '--' }}</div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
          <el-tab-pane label="设备状态">
            <div class="cell">
              <el-row>
                <!-- <el-col :span="4">
                  <div class="label">设备名称</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">状态</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">设备状态</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">状态</div>
                </el-col> -->
                <el-col :span="4">
                  <div class="label">TBOX</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.tbox }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">太阳能</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.solarEnergy }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">控制屏</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.controlPanel }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">智能功放</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.smartPower }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">水位模块</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.waterModule }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">锂电池</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.battery }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">电池管理模块</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.battery }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">空调</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.airConditioner }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">新风</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.freshAir }}</div>
                </el-col>
              </el-row>
            </div>
            <div class="cell">
              <el-row>
                <el-col :span="4">
                  <div class="label">逆变器</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.inverter }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">通讯模块</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.communicationModule }}</div>
                </el-col>
                <el-col :span="4">
                  <div class="label">燃油加热器</div>
                </el-col>
                <el-col :span="4">
                  <div class="value">{{ statusInfo.fuelHeater }}</div>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCarData, getCarState } from '@/api/home';
import { getMaintains } from '@/api/maintain';
export default {
  data() {
    return {
      /*******************************new version**********************************/
      name: '--', //租车人
      phone: '--', //租车人电话
      endTime: '--', //到期日期
      GPSPosition: '', //GPS位置 (longitude,latitude)
      longitude: '--', //经度
      latitude: '--', //纬度
      asl: '--', //海拔高度
      speed: '--', //GPS速度
      carPose: '', //车辆姿态(aftAngle,rightAngle)
      aftAngle: '--', //俯仰
      rightAngle: '--', //倾斜
      acceleration: '--', //加速度
      carSpeed: '--', //车速
      gear: '--', //档位
      rotatingSpeed: '--', //发动机转速
      direction: '--', //方向
      waterTemperature: '--', //发动机水温
      oilLevel: '--', //车辆油量
      voltage: '--', //电池电压
      carAlarm: '--', //车辆告警
      antiTheft: '--', //防盗报警
      motorIndication: '--', //发电状态 （发电、未发电2种状态）
      waterClear: '--', //清水水量
      greyWater: '--', //灰水水量
      blackWater: '--', //黑水报警  1报警  0未报警
      smokeAlarm: '--', //烟雾告警
      gasAlarm: '--', //燃气告警
      coAlarm: '--', //CO告警
      electriServiceLevel: '--', //服务电量
      drawBinStatus: '--', //抽拉仓状态
      gateSignal: '--', //门（有打开、全关闭）
      numberPlate: '--',
      handbrake: '--', //手刹信号 1刹车 ,0未刹车
      online: '--', //车辆状态
      /*******************************old version**********************************/
      //speed: '13',//车速
      //direction: '250',//方向
      handbrake: '0x00', //手刹信号
      signal: '0', //车门状态
      powerremain: '0', //启动电瓶电量
      temperature_out: '0', //车外温度
      water_clear: '0', //清水剩余水量
      //asl: '0',//海拔
      reporting_address: '0', //最后一次上报地址
      max_speed: '0', //最高车速
      frame_num: '0', //车架号
      sn: '0', //TBOX编号
      work_num: '0', //车辆编号
      number_plate: '0', //车牌号
      everyone: '0', //所有人
      owned_company: '0', //车辆所属公司
      car_status: '0', //车辆运动状态
      b_user_name: '0', //B端用户名
      sim_margin: '0', //sim卡剩余流量
      expiration_date: '0', //sim有效期
      total_mileage: '0', //总里程
      remaining_battery: '0', //剩余电量
      tanker_state: '0', //油拉舱状态
      mileage_current_tenant: '0', //当前租户行驶里程
      max_asl: '0', //最高海拔
      max_temperature: '0', //最高温度
      min_temperature: '0', //最低温度
      powervoltage: '0', //电压
      iccid: '',
      abnormalInvasion: '',
      powerAlarm: '',
      longitude: '',
      latitude: '',
      mainTain: {
        problem: '',
        status: '',
        person: '',
        create_time: '',
        solve_time: '',
      },
      statusInfo: {},
      statusList: ['未解决', '已解决'],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    close() {
      this.$parent.closeCarDialog();
    },
    //非空判断
    isNotEmpty(str) {
      if (str != null && str != '' && str.trim().length > 0) {
        return true;
      }
      // console.log(str)
      return false;
    },
    getMaintains() {
      getMaintains;
    },
    getData() {
      const data = { frameNum: this.$parent.frame_num };
      GetCarData(data).then((ret) => {
        let res = ret.data;
        if (res.frameNum) {
          this.frame_num = res.frameNum;
          getMaintains({ frame_num: res.frameNum, sort: 1 }).then((da) => {
            this.mainTain = da.data.content[0] || {};
          });
          getCarState({ frameNum: res.frameNum }).then((da) => {
            this.statusInfo = da.data;
            console.log(this.statusInfo);
          });
        } else {
          this.statusInfo = {};
          this.frame_num = '0';
          this.mainTain = {
            problem: '',
            status: '',
            person: '',
            create_time: '',
            solve_time: '',
          };
        }
        this.endTime = this.isNotEmpty(res.endTime)
          ? res.endTime
          : this.endTime;
        this.numberPlate = this.isNotEmpty(res.numberPlate)
          ? res.numberPlate
          : this.numberPlate;
        this.name = this.isNotEmpty(res.name) ? res.name : this.name;
        this.phone = this.isNotEmpty(res.phone) ? res.phone : this.phone;
        this.asl = this.isNotEmpty(res.asl) ? res.asl + ' m' : this.asl;
        this.iccid = res.iccid || '--';
        this.sn = res.sn || '--';
        this.abnormalInvasion = res.abnormalInvasion || '--';
        this.powerAlarm = res.powerAlarm || '--';
        this.latitude = res.latitude || '--';
        this.longitude = res.longitude || '--';
        this.number_plate = res.numberPlate || '--';
        if (this.isNotEmpty(res.speeds) && res.speeds == '--') {
          this.speed = '--';
        } else if (
          this.isNotEmpty(res.speeds) &&
          Math.floor(res.speeds) == -1
        ) {
          this.speed = '--';
        } else if (this.isNotEmpty(res.speeds)) {
          this.speed = res.speeds + ' km/h';
        } else {
          this.speed = '--';
        }
        let carPoseInfo = '';
        if (this.isNotEmpty(res.aftAngle) && Math.floor(res.aftAngle) == -1) {
          carPoseInfo = '--';
        } else if (
          this.isNotEmpty(res.aftAngle) &&
          !this.isNotEmpty(res.rightAngle)
        ) {
          carPoseInfo = '(俯仰:' + res.aftAngle + '°)';
        } else if (
          this.isNotEmpty(res.rightAngle) &&
          !this.isNotEmpty(res.aftAngle)
        ) {
          carPoseInfo = '(左右:' + res.rightAngle + '°)';
        } else if (
          this.isNotEmpty(res.aftAngle) &&
          this.isNotEmpty(res.rightAngle) &&
          (res.aftAngle > 0 || res.rightAngle > 0)
        ) {
          carPoseInfo =
            '(俯仰:' + res.aftAngle + '°,左右:' + res.rightAngle + '°)';
        } else {
          carPoseInfo = '--';
        }

        this.carPose = carPoseInfo;
        //加速度
        if (
          this.isNotEmpty(res.acceleration) &&
          Math.floor(res.acceleration) == 0
        ) {
          this.acceleration = '正常';
        } else if (
          this.isNotEmpty(res.acceleration) &&
          Math.floor(res.acceleration) == 2
        ) {
          this.acceleration = '前后碰撞';
        } else if (
          this.isNotEmpty(res.acceleration) &&
          Math.floor(res.acceleration) == 3
        ) {
          this.acceleration = '左右碰撞';
        } else {
          this.acceleration = '--';
        }

        if (this.isNotEmpty(res.carSpeed) && res.carSpeed == '--') {
          this.carSpeed = '--';
        } else if (
          this.isNotEmpty(res.carSpeed) &&
          Math.floor(res.carSpeed) == -1
        ) {
          this.carSpeed = '--';
        } else if (this.isNotEmpty(res.carSpeed)) {
          this.carSpeed = res.carSpeed;
        } else {
          this.carSpeed = '--';
        }
        let gearS = '';
        if (this.isNotEmpty(res.gear) && Math.floor(res.gear) == -1) {
          gearS = '--';
        } else if (this.isNotEmpty(res.gear) && Math.floor(res.gear) == 0) {
          gearS = 'N档';
        } else if (this.isNotEmpty(res.gear) && Math.floor(res.gear) == -2) {
          gearS = 'R档';
        } else if (this.isNotEmpty(res.gear) && Math.floor(res.gear) == -3) {
          gearS = 'P档';
        } else if (this.isNotEmpty(res.gear) && res.gear == '--') {
          gearS = '--';
        } else if (this.isNotEmpty(res.gear)) {
          gearS = Math.floor(res.gear) + '档';
        }
        this.gear = gearS;
        let onlineS = '';
        if (Math.floor(res.online) == 0) {
          onlineS = '离线';
        } else if (Math.floor(res.online) == 1) {
          onlineS = '实时数据';
        } else {
          onlineS = '--';
        }
        this.online = onlineS;

        if (this.isNotEmpty(res.rotatingSpeed) && res.rotatingSpeed == '--') {
          this.rotatingSpeed = '--';
        } else if (
          this.isNotEmpty(res.rotatingSpeed) &&
          Math.floor(res.rotatingSpeed) == -1
        ) {
          this.rotatingSpeed = '--';
        } else if (this.isNotEmpty(res.rotatingSpeed)) {
          this.rotatingSpeed = res.rotatingSpeed;
        }

        if (this.isNotEmpty(res.direction) && res.direction == '--') {
          this.direction = '--';
        } else if (
          this.isNotEmpty(res.direction) &&
          Math.floor(res.direction) == -1
        ) {
          this.direction = '--';
        } else if (this.isNotEmpty(res.direction)) {
          this.direction = res.direction;
        }

        if (
          this.isNotEmpty(res.waterTemperatures) &&
          res.waterTemperatures == '--'
        ) {
          this.waterTemperature = '--';
        } else if (
          this.isNotEmpty(res.waterTemperatures) &&
          Math.floor(res.waterTemperatures) == -1
        ) {
          this.waterTemperature = '--';
        } else if (this.isNotEmpty(res.waterTemperatures)) {
          this.waterTemperature = res.waterTemperatures + ' ℃';
        } else {
          this.waterTemperature = '--';
        }

        let oilLevelS = '';
        if (this.isNotEmpty(res.oilLevel) && res.oilLevel == '--') {
          oilLevelS = '--';
        } else if (
          this.isNotEmpty(res.oilLevel) &&
          Math.floor(res.oilLevel) == -1
        ) {
          oilLevelS = '--';
        } else if (this.isNotEmpty(res.oilLevel)) {
          oilLevelS = Math.floor(res.oilLevel) + ' %';
        } else {
          oilLevelS = '--';
        }
        this.oilLevel = oilLevelS;
        if (this.isNotEmpty(res.voltage) && res.voltage == '--') {
          this.voltage = '--';
        } else if (this.isNotEmpty(res.voltage)) {
          this.voltage = res.voltage + ' V';
        } else if (
          this.isNotEmpty(res.voltage) &&
          Math.floor(res.voltage) == -1
        ) {
          this.voltage = res.voltage + ' V';
        } else {
          this.voltage = '--';
        }

        if (Math.floor(res.antiTheft) == 0) {
          this.antiTheft = '正常';
        } else if (Math.floor(res.antiTheft) == 1) {
          this.antiTheft = '告警';
        } else {
          this.antiTheft = '--';
        }

        //0未发电  1发电
        if (Math.floor(res.motorIndication) == 0) {
          this.motorIndication = '未发电';
        } else if (Math.floor(res.motorIndication) == -1) {
          this.motorIndication = '--';
        } else if (res.motorIndication == '--') {
          this.motorIndication = '--';
        } else {
          this.motorIndication = '发电';
        }

        if (this.isNotEmpty(res.waterClear) && res.waterClear == '--') {
          this.waterClear = '--';
        } else if (
          this.isNotEmpty(res.waterClear) &&
          Math.floor(res.waterClear) == -1
        ) {
          this.waterClear = '--';
        } else {
          this.waterClear = res.waterClear + ' %';
        }

        if (this.isNotEmpty(res.greyWater) && res.greyWater == '--') {
          //灰水水量
          this.greyWater = '--';
        } else if (
          this.isNotEmpty(res.greyWater) &&
          Math.floor(res.greyWater) == -1
        ) {
          this.greyWater = '--';
        } else {
          this.greyWater = res.greyWater + ' %';
        }

        //黑水报警
        if (Math.floor(res.blackWater) == 1) {
          this.blackWater = '报警';
        } else if (Math.floor(res.blackWater) == 0) {
          this.blackWater = '未报警';
        } else if (Math.floor(res.blackWater) == '--') {
          this.blackWater = '未报警';
        } else {
          this.blackWater = '--';
        }

        //烟雾告警
        if (Math.floor(res.smokeAlarm) == 1) {
          this.smokeAlarm = '报警';
        } else if (Math.floor(res.smokeAlarm) == 0) {
          this.smokeAlarm = '未报警';
        } else {
          this.smokeAlarm = '--';
        }

        //燃气告警
        if (Math.floor(res.gasAlarm) == 1) {
          this.gasAlarm = '报警';
        } else if (Math.floor(res.gasAlarm) == 0) {
          this.gasAlarm = '未报警';
        } else {
          this.gasAlarm = '--';
        }

        //CO告警
        if (Math.floor(res.coAlarm) == 1) {
          this.coAlarm = '报警';
        } else if (Math.floor(res.coAlarm) == 0) {
          this.coAlarm = '未报警';
        } else {
          this.coAlarm = '--';
        }

        //this.electriServiceLevel = res.electriServiceLevel //服务电量
        //抽拉仓状态 0关闭  1开
        if (Math.floor(res.drawBinStatus) == 1) {
          this.drawBinStatus = '开';
        } else if (Math.floor(res.drawBinStatus) == 0) {
          this.drawBinStatus = '关闭';
        } else {
          this.drawBinStatus = '--';
        }

        //刹车信号
        if (Math.floor(res.handbrake) == 1) {
          this.handbrake = '刹车';
        } else if (Math.floor(res.handbrake) == 0) {
          this.handbrake = '未刹车';
        } else {
          this.handbrake = '--';
        }

        let gateSignalSt = '';
        if (this.isNotEmpty(res.gateSignals)) {
          gateSignalSt = Math.floor(res.gateSignals) + '';
        }
        if (Math.floor(gateSignalSt) == -1) {
          this.gateSignal = '--';
        } else if (gateSignalSt == '80') {
          this.gateSignal = '全部关闭';
        } else if (gateSignalSt == '81') {
          this.gateSignal = '驾驶室门开启';
        } else if (gateSignalSt == '82') {
          this.gateSignal = '副驾驶门开启';
        } else if (gateSignalSt == '83') {
          this.gateSignal = '驾驶室门、副驾驶门开启';
        } else if (gateSignalSt == '84') {
          this.gateSignal = '驾驶室门、左侧门开启';
        } else if (gateSignalSt == '85') {
          this.gateSignal = '左侧门开启';
        } else if (gateSignalSt == '86') {
          this.gateSignal = '副驾驶门、左侧门开启';
        } else if (gateSignalSt == '87') {
          this.gateSignal = '驾驶室门、副驾驶门、左侧门开启';
        } else if (gateSignalSt == '88') {
          this.gateSignal = '右侧门开启';
        } else if (gateSignalSt == '89') {
          this.gateSignal = '驾驶室门、右侧门开启';
        } else if (gateSignalSt == '90') {
          this.gateSignal = '后门开启';
        } else if (gateSignalSt == '91') {
          this.gateSignal = '驾驶室门、后门开启';
        } else if (gateSignalSt == '92') {
          this.gateSignal = '副驾驶门，后门开启';
        } else if (gateSignalSt == '93') {
          this.gateSignal = '驾驶室门、副驾驶门，后门开启';
        } else if (gateSignalSt == '94') {
          this.gateSignal = '左侧门，后门开启';
        } else if (gateSignalSt == '95') {
          this.gateSignal = '驾驶室门、左侧门、后门开启';
        } else if (gateSignalSt == '96') {
          this.gateSignal = '副驾驶门，左侧门，后门开启';
        } else if (gateSignalSt == '97') {
          this.gateSignal = '驾驶室门、副驾驶门、左侧门、后门开启';
        } else if (gateSignalSt == '98') {
          this.gateSignal = '右侧门、后门开启';
        } else if (gateSignalSt == '99') {
          this.gateSignal = '驾驶室门、右侧门、后门开启';
        } else if (gateSignalSt == '128') {
          this.gateSignal = '全部关闭';
        } else if (gateSignalSt == '129') {
          this.gateSignal = '驾驶室门开启';
        } else if (gateSignalSt == '130') {
          this.gateSignal = '副驾驶门开启';
        } else if (gateSignalSt == '131') {
          this.gateSignal = '驾驶室门、副驾驶门开启';
        } else if (gateSignalSt == '132') {
          this.gateSignal = '驾驶室门、左侧门开启';
        } else if (gateSignalSt == '133') {
          this.gateSignal = '左侧门开启';
        } else if (gateSignalSt == '134') {
          this.gateSignal = '副驾驶门、左侧门开启';
        } else if (gateSignalSt == '135') {
          this.gateSignal = '驾驶室门、副驾驶门、左侧门开启';
        } else if (gateSignalSt == '136') {
          this.gateSignal = '右侧门开启';
        } else if (gateSignalSt == '137') {
          this.gateSignal = '驾驶室门、右侧门开启';
        } else if (gateSignalSt == '138') {
          this.gateSignal = '副驾驶门、右侧门开启';
        } else if (gateSignalSt == '139') {
          this.gateSignal = '驾驶室门、副驾驶门、右侧门开启';
        } else if (gateSignalSt == '140') {
          this.gateSignal = '左侧门、右侧门开启';
        } else if (gateSignalSt == '141') {
          this.gateSignal = '驾驶室门、左侧门、右侧门开启';
        } else if (gateSignalSt == '142') {
          this.gateSignal = '副驾驶门、左侧门、右侧门开启';
        } else if (gateSignalSt == '143') {
          this.gateSignal = '驾驶室门、副驾驶门、左侧门、右侧门开启';
        } else if (gateSignalSt == '144') {
          this.gateSignal = '后门开启';
        } else if (gateSignalSt == '145') {
          this.gateSignal = '驾驶室门、后门开启';
        } else if (gateSignalSt == '146') {
          this.gateSignal = '副驾驶门，后门开启';
        } else if (gateSignalSt == '147') {
          this.gateSignal = '驾驶室门、副驾驶门，后门开启';
        } else if (gateSignalSt == '148') {
          this.gateSignal = '左侧门，后门开启';
        } else if (gateSignalSt == '149') {
          this.gateSignal = '驾驶室门、左侧门、后门开启';
        } else if (gateSignalSt == '150') {
          this.gateSignal = '副驾驶门，左侧门，后门开启';
        } else if (gateSignalSt == '151') {
          this.gateSignal = '驾驶室门、副驾驶门、左侧门、后门开启';
        } else if (gateSignalSt == '152') {
          this.gateSignal = '右侧门、后门开启';
        } else if (gateSignalSt == '153') {
          this.gateSignal = '驾驶室门、右侧门、后门开启';
        } else if (gateSignalSt == '0.0') {
          this.gateSignal = '--';
        }
        this.GPSPosition =
          '(' + this.isNotEmpty(res.longitude)
            ? res.longitude
            : '' + ',' + this.isNotEmpty(res.latitude)
            ? res.latitude
            : '' + ')';
        let GPSp = '';
        if (this.isNotEmpty(res.longitude) && !this.isNotEmpty(res.latitude)) {
          GPSp = '(' + res.longitude + ')';
        } else if (
          this.isNotEmpty(res.latitude) &&
          !this.isNotEmpty(res.longitude)
        ) {
          GPSp = '(' + res.latitude + ')';
        } else if (
          res.longitude != 0 &&
          res.latitude != 0 &&
          this.isNotEmpty(res.longitude) &&
          this.isNotEmpty(res.latitude)
        ) {
          GPSp = '(' + res.longitude + ',' + res.latitude + ')';
        } else {
          GPSp = '--';
        }
        this.GPSPosition = GPSp;
        /*
          if(res.speed=='0xFF'){
              this.speed = ' '
          }else{
              this.speed = res.speed+'km/h'
          }
          if(res.direction=='0xFFFF'){
              this.direction = ' '
          }else{
              this.direction = res.direction+'°'
          }
          if(res.handbrake=='0x00'){
              this.handbrake = '未刹车'
          }else if(res.handbrake=='0x01'){
              this.handbrake = '已刹车'
          }else{
              this.handbrake = ' '
          }
          this.signal = res.signal
          this.powerremain = res.powerremain
          if(res.temperature_out=='0xFF'){
            this.temperature_out = ' '
          }else{
            this.temperature_out = res.temperature_out+'℃'
          }
          this.water_clear = res.water_clear
          if(res.asl=='0xFFFF'){
            this.asl = ' '
          }else{
            this.asl = res.asl
          }
          this.reporting_address = '(' + res.longitude=='0xFFFFFFFF'?' ':res.longitude + ',' + res.latitude=='0xFFFFFFFF'?' ':res.latitude + ')'
          this.max_speed = res.max_speed	
          this.frame_num = res.frame_num	
          this.sn = res.sn
          this.work_num = res.work_num == null?' ':res.work_num
          this.number_plate = res.number_plate == null?' ':res.number_plate
          this.everyone = res.everyone == null?' ':res.everyone
          this.owned_company = res.owned_company == null?' ':res.owned_company
          if(res.car_status=='0'){
            this.car_status = '关'
          }else{
            this.car_status = '开'
          }
          this.b_user_name = res.b_user_name
          this.sim_margin = res.sim_margin
          this.expiration_date = res.expiration_date	
          this.total_mileage = res.total_mileage
          if(res.remaining_battery=='0xFF'){
            this.remaining_battery = ' '
          }else{
            this.remaining_battery = res.remaining_battery
          }
          this.tanker_state = res.tanker_state
          this.mileage_current_tenant = res.mileage_current_tenant
          this.max_asl = res.max_asl
          this.max_temperature = res.max_temperature
          this.min_temperature = res.min_temperature
          this.powervoltage = res.powervoltage
          */
      });
    },
  },
};
</script>

<style lang="less" scoped>
.car-dialog-containter {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
  .inner {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 900px;
    transform: translate(-50%, -50%);
    background: rgba(15, 8, 54, 0.6);
    border: 1px solid #00728b;
    box-shadow: 1px 1px 10px #00728b;
  }
  .title {
    position: relative;
    color: #51aefe;
    font-size: 18px;
    text-align: center;
    line-height: 2.4em;
    letter-spacing: 2px;
    .close {
      position: absolute;
      right: 10px;
      top: 0;
      padding: 10px;
      line-height: 1em;
      cursor: pointer;
      .iconfont {
        color: #fff;
        font-size: 18px;
      }
    }
  }
  .box {
    padding: 4px 10px 26px;
    // display: flex;
    color: #fff;
    .cell {
      margin-top: 20px;
    }
    .label {
      text-align: right;
      padding-right: 20px;
      color: #ededee;
    }
    .value {
      color: #999;
      word-break: break-all;
      word-wrap: break-word;
      // height: 19px;
    }
  }
  .GPS {
    white-space: nowrap;
  }
}
/deep/.el-tabs {
  flex-direction: row;
}
</style>
